
    const data = {"name":"src/core/icons/home","data":{"viewBox":"0 0 50 50","data":"<path pid=\"0\" d=\"M25 9.094 7.281 25.374h5.563v15.532h24.312V25.375h5.563L25 9.094z\" _fill=\"#000\"/>","originalColors":[{"type":"fill","color":"#000"}],"stopColors":[]}}

            export default data
            